import { Component, Input } from '@angular/core';
import { DialogConfirmationComponent } from '../../../dialog-confirmation/dialog-confirmation.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-info-modal',
    templateUrl: './info-modal.component.html',
    styleUrls: ['./info-modal.component.scss']
})
export class InfoModalComponent {
    @Input() textModal: string;
    @Input() titleModal: string;
    @Input() accentColor: boolean = false;
    @Input() larger?: boolean = false;

    constructor(private dialog: MatDialog) { }

    helpClick() {
        this.dialog.open(DialogConfirmationComponent, {
            data: {
                title: this.titleModal,
                content: this.textModal,
                isConfirmation: false,
                larger: this.larger
            }
        });
    }

    getIconBackgroundColor(): string {
        return this.accentColor ? 'var(--brand-accent)' : '#FFF';
    }
}
